export const FSC_TYPE = {
  ALL_IN: 'all in',
  VIA_INTEGRATION: 'via integration',
  FLAT_AMOUNT: 'flat $',
  FLAT_PERCENT: 'flat %',
  VARIABLE_PERCENT: 'variable %',
  VARIABLE_AMOUNT_PER_MILE: 'variable $/mile',
};

export const FSC_SOURCE = {
  CARGOMATIC: 'cargomatic',
  REGIONAL: 'regional',
  CUSTOMER_SPECIFIC: 'customer_specific',
};

export const FUEL_SURCHARGE_TYPE = {
  PERCENT: 'percent',
  COST_PER_MILE: 'cost_per_mile',
};

export const FSC_CONFIG_ACCOUNT_TYPE = {
  SHIPPER: 'shipper',
  CARRIER: 'carrier',
};

export const FSC_CALCULATION_FREQUENCY = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const FUEL_PRICE_WEEK = {
  CURRENT_WEEK: 'current week',
  PREVIOUS_WEEK: 'previous week',
};

export const FSC_EFFECTIVE_DAY = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
};

export const FSC_IMPORT_ANCHOR_EVENTS = {
  TENDER_DATE: 'tender date',
  LOADED_PICKUP_DATE: 'loaded pickup date',
  LOADED_DELIVERY_DATE: 'loaded delivery date',
  EMPTY_RETURN_DATE: 'empty return date',
};

export const FSC_EXPORT_ANCHOR_EVENTS = {
  TENDER_DATE: 'tender date',
  EMPTY_PICKUP_DATE: 'empty pickup date',
  LOADED_PICKUP_DATE: 'loaded pickup date',
  LOADED_DELIVERY_DATE: 'loaded delivery date',
};

export const FSC_REPOSITION_ANCHOR_EVENTS = {
  TENDER_DATE: 'tender date',
  PICKUP_DATE: 'pickup date',
  DELIVERY_DATE: 'delivery date',
};
